@if (!state.isReady()) {
  <ch-status [state]="state" (buttonEvent)="showAnyway()"></ch-status>
}

<div class="row">
  <div class="col-md-8">
    <div id="scatterplot"></div>
  </div>
  @if (state.isReady()) {
    <div class="col-md-4" id="setting">
      <h6 class="lighter mb-0">Parameters</h6>
      <label for="selectXaxis" class="text-sm">X-axis</label>
      <select
        class="form-control"
        id="selectXaxis"
        [(ngModel)]="selectedXAxisHeader"
        (ngModelChange)="setXAxisHeader($event)">
        @for (header of chipHeaders; track $index) {
          <option>{{ header }}</option>
        }
      </select>

      <label for="selectYaxis" class="text-sm">Y-Axis</label>
      <select
        class="form-control"
        id="selectYaxis"
        [(ngModel)]="selectedYAxisHeader"
        (ngModelChange)="setYAxisHeader($event)">
        @for (header of chipHeaders; track $index) {
          <option class="text-sm">{{ header }}</option>
        }
      </select>
      <div id="selectedGeneList">
        <h6 class="lighter mt-4">Selection</h6>
        @if (selectedDataRows && selectedDataRows.length > 0) {
          <div class="d-flex align-items-center mb-3">
            <p class="text-sm mb-0">{{ selectedDataRows.length }}/{{ plotData.length }} features</p>
            <button class="btn btn-primary btn-sm ms-auto" (click)="createDatasetFromSelected()">Create file</button>
          </div>
          <hr class="mt-1 mb-2" />
          <table class="table table-sm text-sm">
            <thead>
              <tr>
                @if (showSymbolColumn) {
                  <th scope="col">Symbol</th>
                }
                <th scope="col">Identifier</th>
              </tr>
            </thead>
            <tbody>
              @for (selection of viewSelectionList; track $index) {
                <tr>
                  @if (showSymbolColumn) {
                    <td>{{ selection.symbol }}</td>
                  }
                  <td>{{ selection.identifier }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="fst-italic text-smaller">Select features by clicking or drawing a rectangle</p>
        }
      </div>
    </div>
  }
</div>
